module.exports = __webpack_public_path__ + "img/testimonials-icon-orange.7f6882fc.svg";